import { useMemo } from 'react';

import useOverviewConfig from '../../components/Overview/use-overview-config.hook';
import { EXCLUDE_KIT_FIELDS } from './exclude-kit-fields';
import { FieldType } from './types';

type SaveKitFieldIds = (ids: FieldType[]) => void;

/**
 * Manages kit field configuration for the kits overview.
 *
 * Reads and writes the overview config storage.
 *
 * @returns Tuple of [selectedFieldIds, saveFunction]
 */
export const useKitFieldsConfig = (): [FieldType[], SaveKitFieldIds] => {
	const [kitsConfig, setOverviewConfig] = useOverviewConfig<FieldType>({ type: 'kits-list', view: 'table' });

	const inlineFields = useMemo(() => {
		return (kitsConfig?.inlineFields ?? []).filter((field) => !EXCLUDE_KIT_FIELDS.includes(field));
	}, [kitsConfig?.inlineFields]);

	const saveInlineFields: SaveKitFieldIds = (ids: FieldType[]) => {
		setOverviewConfig({
			...kitsConfig,
			inlineFields: ids,
		});
	};

	return [inlineFields, saveInlineFields];
};

export default useKitFieldsConfig;
